import request from '@/utils/request'
import {uuid} from 'vue-uuid'

export function getPricing(project_uid, currency_uid){
  return request({
    url: `/api/pricings/${project_uid}/currency/${currency_uid}`,
    method: "get"
  });
}

export function updatePricing(project_uid, currency_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/pricings/${project_uid}/currency/${currency_uid}`,
    method: "post",
    data: data
  });
}

export function clonePricing(project_uid, currency_uid, data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/pricings/${project_uid}/currency/${currency_uid}/cloning`,
    method: "post",
    data: data
  });
}

export function getPricingTemplate(){
  return request({
    url: `/api/pricings/template`,
    method: "get"
  });
}

export function updatePricingTemplate(data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/pricings/template`,
    method: "put",
    data: data
  });
}

export function addPricingTemplate(data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/pricings/template`,
    method: "post",
    data: data
  });
}

export function editPricingTemplate(data){
  data.idempotency = uuid.v1()
  return request({
    url: `/api/pricings/template/${data.pricing_code}`,
    method: "put",
    data: data
  });
}

export function getPricingHeader(){
  return request({
    url: `/api/pricings/group`,
    method: "get"
  });
}